// Количество голосов за предсказание темперамента друга
export const FRIEND_PREDICTION_PRICE = 1;
